import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  entity_type: 1;
  percentage: boolean;
  description: boolean;
}
export const useCreateProfileRelationType = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/profile_relationship_type/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
